import { CampaignModel } from './CampaignModel';
import { CampaignTreeModel } from './CampaignTreeModel';
import { CampaignUDF1StepModel } from './CampaignUDF1StepModel';
import { CardResult } from './CardResult';
import { RequestCTreeModel, RequestTreeModel } from './RequestTreeModel';
import { RequestUdfModel } from './RequestUdfModel';
import { UdfControlType } from './UdfControlType';

export class RequestModel {
    requestId: number;
    campaignId: number;
    campaignDesc: string;
    firstName: string;
    lastName: string;
    organization: string | null;
    email: string;
    primaryPhone: string;
    primaryPhoneType: string | null = "Mobile";
    alternativePhone: string | null;
    alternativePhoneType: string | null = "Mobile";
    mailAddress: string;
    mailCity: string;
    mailState: string = null;
    mailZip: string;
    billingAddress: string;
    billingCity: string;
    billingState: string = null;
    billingZip: string;
    sameAsMail = false;
    sameAsMail2 = false;
    plantingAddress: string;
    plantingCity: string;
    plantingState: string = null;
    plantingZip: string;
    neighborhoodId = -1;
    neighborhoodDesc: string = null;
    distributionId: number;
    distributionDesc: string = null;
    isTargetNeighborhood = false;
    neededTreeship = false;
    ifTreeshipParagraph: string | null;

    // From Campaign
    displayTreeship: boolean;


    // Step 2
    //
    ifNotAvailableNum: number;
    notAvailableText = '';
    ifNotAvailableSpeciesIWant: string | null;

    // Step 3
    initialsAcceptAbove: string;
    initialsReleaseOfLiability: string;

    // Step 4
    //
    couponCode = '';
    couponMultiplier = 1;
    donationAmount: number;
    mulchFee: number = 0;
    customerProfileId = 0;
    customerProfileDesc: string;
    customerPaymentProfileId = 0;
    customerPaymentProfileDesc: string;
    last4OfCard: string;
    donationLetterSent = false;
    spanishOnly = false;
    pickedUp = true;
    comments: string | null;

    trees: RequestTreeModel[];
    udfs: RequestUdfModel[];
    ctrees: RequestCTreeModel[];
    // udf1: CampaignUDF1StepModel[];

    // for payment
    //
    treeTotalAmount = 0;
    firstNameCard: string;
    lastNameCard: string;
    cardNumber: string;
    expirationMonth: string = null;
    expirationYear: number = null;
    expirationDate: string;
    cvv: string;
    amountDueNow = 0;
    waitListAmount = 0;
    paymentAmount = 0;

    isNew = true;
    mail: string;
    profileResult: CardResult;
    chargeResult: CardResult;

    emailHtmlHeader: string;
    emailHtmlFooter: string;

    waitQtyTotal = 0;

    addTrees(trees: CampaignTreeModel[]): void {
        this.trees = [];
        this.ctrees = [];
        for (const ctree of trees) {
            this.addTree(ctree, ctree.qty1, ctree.cost1, ctree.isWaitlist, ctree.plantingLocationID1, ctree.planting1LocationName);
            this.addTree(ctree, ctree.qty2, ctree.cost2, ctree.isWaitlist, ctree.plantingLocationID2, ctree.planting2LocationName);
            this.addTree(ctree, ctree.qty3, ctree.cost3, ctree.isWaitlist, ctree.plantingLocationID3, ctree.planting3LocationName);
            this.addTree(ctree, ctree.qty4, ctree.cost4, ctree.isWaitlist, ctree.plantingLocationID4, ctree.planting4LocationName);

            if (ctree.qty > 0) {
                const ctreeReq = new RequestCTreeModel();
                ctreeReq.treeCommonName = ctree.treeCommonName;
                ctreeReq.planting1LocationName = ctree.planting1LocationName;
                ctreeReq.planting2LocationName = ctree.planting2LocationName;
                ctreeReq.planting3LocationName = ctree.planting3LocationName;
                ctreeReq.planting4LocationName = ctree.planting4LocationName;

                ctreeReq.qty1 = ctree.qty1;
                ctreeReq.qty2 = ctree.qty2;
                ctreeReq.qty3 = ctree.qty3;
                ctreeReq.qty4 = ctree.qty4;
                ctreeReq.isWaitlist = ctree.isWaitlist;

                this.ctrees.push(ctreeReq);
            }
        }
    }

    addUdfs(campaign: CampaignModel): void {
        this.udfs = [];
        this.addUdf(campaign.udf1, 1);
        this.addUdf(campaign.udf3, 3);
    }

    formWants(campaign: CampaignModel): void {
        let s = '';
        for (const tree of campaign.displayNotAvail) {
            if (tree.isSelected) {
                if (s !== '') {
                    s += ',';
                }
                s += tree.treeCommonName;
            }
        }
        this.ifNotAvailableSpeciesIWant = s;
    }

    // formExpirationDate(): void {
    //     // let month: string =  this.expirationMonth > 9 ? this.expirationMonth.toString() : '0' + this.expirationMonth;
    //     this.expirationDate = `${this.expirationYear}-${this.expirationMonth}`;
    // }

    emailHtmlText(campaign: CampaignModel): void {
        this.emailHtmlHeader = campaign.emailHtmlHeader;
        this.emailHtmlFooter = campaign.emailHtmlFooter;
    }

    private addUdf(udfs: CampaignUDF1StepModel[], step: number): void {
        for (const udf of udfs) {
            if (udf.uDFIControlType === UdfControlType.Header) {
                continue;
            }
            const u = new RequestUdfModel();
            u.UdfId = udf.UdfId;
            u.rUDFTitle = '';
            u.requestId = 0,
                u.rUDFStep = step;
            u.rUDFIDisplayOrder = 0;
            u.rUDFTitle = udf.uDFTitle;

            if (udf.uDFIControlType === UdfControlType.CheckBox) {
                u.rUDFValue = udf.value === true ? 'Yes' : 'No';
            }
            else {
                u.rUDFValue = udf.value as string;
            }
            u.rUDFValue = u.rUDFValue === null ? '' : u.rUDFValue;

            this.udfs.push(u);

        }
    }

    private addTree(ctree: CampaignTreeModel, qty: number, cost: number, isWaitlest: number,
         location: number, locationName:string): void {
        if (qty <= 0) {
            return;
        }
        const tree = new RequestTreeModel();
        tree.campaignTreeId = ctree.campaignTreeId;
        tree.requestQnty = qty;
        tree.costPerQnty = cost;
        tree.isWaitlist = ctree.isWaitlist === 1 ? true : false;
        tree.plantingLocationId = location;
        tree.plantingLocationText = locationName;
        tree.treeName = ctree.treeCommonName;
        this.trees.push(tree);
    }
}
